<template>
  <div id="paginaDistintePagamenti">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Distinte Pagamenti</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnniRiferimento" ref="dropAnniRiferimento" :query="queryAnno"
                  :dataSource="annoRiferimentoList" :index="annoIndex" :fields="annoRiferimentoFields"
                  :change="onAnnoRiferimentoChange" v-model="annoRiferimentoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="pt-1">
                <ejs-grid id="gridA" ref="gridA" :dataSource="distintePagamentoFullData" :allowSorting="true"
                  :sortSettings="gridA.sortOptions" :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions"
                  :height="gridA.height" :allowFiltering="true" :filterSettings="gridA.filterOptions"
                  :editSettings="gridA.editOptions">
                  <e-columns>
                    <e-column field="id" headerText="ID" :isPrimaryKey="true" width="50"></e-column>
                    <e-column field="numero" headerText="Numero" width="100"></e-column>
                    <e-column field="data" headerText="Data" :format="settings.formatoData" type="date"
                              width="50"></e-column>
                    <e-column field="conto" headerText="Conto" width="60" foreignKeyField="val"
                              foreignKeyValue="label" :dataSource="this.contoList"></e-column>
                    <e-column field="stato" headerText="Stato" width="30" foreignKeyField="val"
                              foreignKeyValue="label" :dataSource="this.distinteStatoList"></e-column>
                    <e-column field="descrizione" headerText="Descrizione" width="120"></e-column>
                    <e-column field="totale" headerText="Totale" width="50" format='######.##'></e-column>
                  </e-columns>
                  <e-aggregates>
                    <e-aggregate>
                      <e-columns>
                        <e-column type="Sum" field="totale" format="Tot € ######.##"></e-column>
                      </e-columns>
                    </e-aggregate>
                  </e-aggregates>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA: dialogDettaglioDistinta ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA" ref="dialogA" :header="dialogA.header" :buttons="dialogA.buttons" :visible="dialogA.visible"
      :showCloseIcon="dialogA.showCloseIcon" :close="dialogAClose" :open="dialogAOpen" :zIndex="dialogA.zIndex"
      :animationSettings="dialogA.animationSettings" :isModal="dialogA.isModal">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA" v-model="dialogA.tabAdialogAIndex">
        <b-tab title="Dati Distinta Pagamento">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dati Distinta Pagamento</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="id" class="h5">Id</label>
                      <ejs-textbox id="id" v-model="distintePagamentoActiveData.id" floatLabelType="Never" cssClass=""
                        placeholder="id" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="data" class="h5">Data</label>
                      <ejs-datepicker id="data" v-model="distintePagamentoActiveData.data"
                        :format="settings.formatoDatepicker" placeholder="Data" :firstDayOfWeek="settings.firstDayOfWeek"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="numero" class="h5">Numero</label>
                      <ejs-textbox id="numero" v-model="distintePagamentoActiveData.numero" floatLabelType="Never" cssClass=""
                                   showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="conto" class="h5">Conto associato</label>
                      <ejs-dropdownlist id="conto" v-model="distintePagamentoActiveData.conto"
                        :dataSource="contoList" :fields="contoFields" :allowFiltering="true"
                        placeholder="Conto associato" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrizione" class="h5">Descrizione</label>
                      <ejs-textbox id="descrizione" v-model="distintePagamentoActiveData.descrizione"
                      floatLabelType="Never" cssClass="" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="stato" class="h5">Stato</label>
                      <ejs-dropdownlist id="conto" v-model="distintePagamentoActiveData.stato"
                        :dataSource="distinteStatoList" :fields="distinteStatoFields" :allowFiltering="true"
                        placeholder="stato distinta" />
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">
                      <ejs-grid id="gridD" ref="gridD" :dataSource="elementiDistintaFullData" :allowSorting="true"
                        :toolbar="gridD.toolbarOptions" :height="gridD.height" :toolbarClick="gridDClickHandler"
                        :allowFiltering="true" :filterSettings="gridD.filterOptions" :editSettings="gridD.editOptions"
                       >
                        <e-columns>
                          <e-column field="id" headerText="ID" :isPrimaryKey="true" width="30" :visible="false"></e-column>
                          <e-column field="denominazione" headerText="Denominazione" width="30"></e-column>
                          <e-column field="iban" headerText="IBAN" width="30"></e-column>
                          <e-column field="importo" headerText="Importo" width="40"></e-column>
                          <e-column field="descrizione" headerText="Descrizione" width="100"></e-column>
                          <e-column field="tipo_pagamento" headerText="Tipologia Pagamento" width="40"></e-column>
                        </e-columns>
                        <e-aggregates>
                          <e-aggregate>
                            <e-columns>
                              <e-column type="Sum" field="importo" format="Tot € ######.##"></e-column>
                            </e-columns>
                          </e-aggregate>
                        </e-aggregates>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>

    <ejs-dialog
      id="dialogB"
      ref="dialogB"
      :header="dialogB.header"
      :buttons="dialogB.buttons"
      :visible="dialogB.visible"
      :showCloseIcon="dialogB.showCloseIcon"
      :close="dialogBClose"
      :open="dialogBOpen"
      :zIndex="dialogB.zIndex"
      :animationSettings="dialogB.animationSettings"
      :height="dialogB.height"
      :width="dialogB.width"
      :isModal="dialogB.isModal"
    >
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogB" v-model="dialogB.tabAdialogBIndex">
        <b-tab title="Dettaglio elemento">
          <b-row class="match-height">
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Elemento distinta pagamento</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="soggetto" class="h5">soggetto</label>
                      <ejs-dropdownlist
                        id="soggetto" ref="soggetto"
                        v-model="elementiDistintaActiveData.soggetto"
                        :dataSource="soggettiList" :fields="soggettiFields"
                        :allowFiltering="true" :filtering="soggettiFiltering"
                        :itemTemplate="itemTemplate" :valueTemplate="valueTemplate"
                        :change="onSoggettoChange" placeholder="Scegli soggetto"
                      />
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                        <label for="dropdownRiferimenti" class="h5">Riferimento</label>
                        <ejs-dropdownlist id='dropdownRiferimenti' ref='dropdownRiferimenti' :dataSource='riferimentiData' placeholder='Nessun riferimento'
                            v-model="elementiDistintaActiveData.riferimento" :fields='riferimentiDataFields' :change='onRiferimentoChange' :dataBound='onRiferimentiBound'></ejs-dropdownlist>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="denominazione" class="h5">Denominazione</label>
                      <ejs-textbox id="denominazione" v-model="elementiDistintaActiveData.denominazione" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="indirizzo" class="h5">Indirizzo residenza</label>
                      <ejs-textbox id="indirizzo" v-model="elementiDistintaActiveData.indirizzo" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="codicefiscale" class="h5">Codice Fiscale</label>
                      <ejs-textbox id="codicefiscale" v-model="elementiDistintaActiveData.codicefiscale" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="iban" class="h5">IBAN</label>
                      <ejs-textbox id="iban" v-model="elementiDistintaActiveData.iban" floatLabelType="Never" cssClass=""
                        placeholder="IBAN soggetto" showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="swift" class="h5">SWIFT (solo per IBAN stranieri)</label>
                      <ejs-textbox id="iban" v-model="elementiDistintaActiveData.swift" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false"/>
                    </b-col>
                    <b-col xl="6" md="6" class="mb-2">
                      <label for="importo" class="h5">Importo</label>
                      <ejs-numerictextbox
                        id="importo" v-model="elementiDistintaActiveData.importo"
                        floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Importo"
                        showSpinButton="false" showClearButton="true"
                      />
                    </b-col>
                    <b-col xl="3" md="3" class="mb-2">
                        <label for="flagAcconto" class="h5 mr-1">Acconto</label>
                        <ejs-checkbox id="flagAcconto" v-model="elementiDistintaActiveData.acconto"
                                                       :checked="elementiDistintaActiveData.acconto"
                            name="flagAcconto" />
                    </b-col>
                    <b-col xl="3" md="3" class="mb-2">
                        <label for="flagSaldo" class="h5 mr-1">Saldo</label>
                        <ejs-checkbox id="flagSaldo" v-model="elementiDistintaActiveData.saldo"
                                                     :checked="elementiDistintaActiveData.saldo"
                            name="flagSaldo" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="descrizione" class="h5">Descrizione</label>
                      <ejs-textbox id="descrizione" v-model="elementiDistintaActiveData.descrizione" floatLabelType="Never" cssClass=""
                        showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="tipologia" class="h5">Tipologia pagamento</label>
                      <ejs-dropdownlist
                        id="tipologia" v-model="elementiDistintaActiveData.tipo_pagamento" :dataSource="tipoList" :fields="tipoFields"/>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
} from "bootstrap-vue";
// import Vuexy
// import Syncfusion

import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
  Aggregate,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);

// api

const apiSoggettiUrl = "/demo/api/soggetto";
const apiDistinteUrl = "/demo/api/distinta";
const apiDistinteGeneraUrl = "/demo/api/distinta/genera";
const apiDistinteBancarioXMLUrl = "/demo/api/distinta/bancario";
const apiDistinteBancarioUrl = "/demo/api/distinta/txt_bancario";
const apiDistinteAnnoUrl = "/demo/api/distinta/anno";
const apiElementiDistintaCreateUrl = "/demo/api/elementodistinta/bulk_create";
const apiElementiDistintaUrl = "/demo/api/elementodistinta";
const apiContoBancarioUrl = '/demo/api/contobancario'
// API ricerca distinte per anno

var itemVue = Vue.component("itemTemplate", {
  template: `<span v-if='data.ragioneSociale'><span class='ragioneSociale' style="float:left; width:500px">{{data.ragioneSociale}}</span><span style='margin-left:2em;'></span><span class ='partitaIva'>{{data.partitaIva}}</span></span>
            <span v-else><span class='cognome' style="float:left; width:500px">{{data.nome}} {{data.cognome}}</span><span style='margin-left:2em;'></span><span class ='codiceFiscale'>{{data.codiceFiscale}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      // praticheVVF
      distintePagamentoFullData: [],
      distintePagamentoActiveId: 0,
      distintePagamentoActiveData: {},
      elementiDistintaFullData: [],
      elementiDistintaActiveData: {},
      elementiDistintaActiveId: 0,
      riferimentiData: {},
      riferimentiDataFields: { text: 'descrizione_riferimento', value: 'id' },
      id_soggetto_distinta: 0,

      // per inizializzazione dropdown a null
      initIndex: -1,
      // per gestione conto
      contoList: [],
      contoFields: { value: "val", text: "label" },
      soggettiList: [],
      soggettiFields: { text: "ragioneSociale", value: "id" },
      tipoList: [
        { label: "Bonifico", val: "bonifico" },
        { label: "Emolumento", val: "emolumento" },
        { label: "Bonifico estero", val: "bonificoEstero" },
      ],
      tipoFields: { text: "label", value: "val" },

      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      annoRiferimentoList: [
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },
      annoIndex: -1,
      queryAnno: null,
      annoRiferimentoCorrente: new Date().getFullYear().toString(),
      // lista valori stato pratica
      distinteStatoList: [
        { label: "Bozza", val: "bozza" },
        { label: "Importata", val: "importata" },
      ],
      distinteStatoFields: { text: "label", value: "val" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA
      dialogA: {
        header: "",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogAOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogACancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogAIndex: 0,
        isModal: false,
      },

      // per dialog B
      dialogB: {
        header: "Elemento distinta",
        visible: false,
        showCloseIcon: true,
        buttons: [
          {
            click: this.dialogBOk,
            buttonModel: { content: "OK", isPrimary: true },
          },
          { click: this.dialogBCancel, buttonModel: { content: "Cancel" } },
        ],
        animationSettings: { effect: "FadeZoom", duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1060,
        tabAdialogBIndex: 0,
        height: "90%",
        width: "90%",
        isModal: true,
      },

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuova Distinta",
            tooltipText: "Crea nuova distinta",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica distinta",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella distinta",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          {
            text: "Download distinta",
            tooltipText: "Download distinta",
            prefixIcon: "e-save",
            id: "download",
          },
          {
            text: "Download file bancario",
            tooltipText: "Download file bancario",
            prefixIcon: "e-save",
            id: "download-bancario",
          },
          {
            text: "Download file XML pagamento",
            tooltipText: "Download file XML pagamento",
            prefixIcon: "e-save",
            id: "download-xml",
          },
          "Search",
        ],
        sortOptions: { columns: [{ field: "data", direction: "Descending" }] },
      },
      // per gridD
      gridDFlag: false,
      gridD: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Nuovo elemento",
            tooltipText: "Aggiungi nuovo elemento",
            prefixIcon: "e-plus",
            id: "new",
          },
          {
            text: "Modifica",
            tooltipText: "Modifica elemento",
            prefixIcon: "e-expand",
            id: "edit",
          },
          {
            text: "Cancella",
            tooltipText: "Cancella elemento",
            prefixIcon: "e-cancel",
            id: "delete",
          },
          "Search",
        ],
      }, //


    };
  },
  created() {
    console.log("Pagina Distinte Pagamento Creata");
    // inizializzazione elenchi dal backend
    // chiamate API

    // recupero elenco PraticheVVF dal backend
    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenco Distinte dal backend");
      // soggetti
      useJwt.get(apiSoggettiUrl).then((d) => {
        if (d.status != 200) {
          console.log("REDIRIGERE A LOGIN");
          alert("Effettua di nuovo il login");
        } else {
          // console.log(d.status);
          // console.log(d.data);
          this.soggettiList = d.data;
        }
      });
      useJwt.get(apiContoBancarioUrl).then((d) => {
        //console.log("Elenco banche");
        //console.log(d.data);
        d.data.forEach((obj) => {
          // console.log(obj)
          this.contoList.push({'label': obj.nome, 'val': obj.id })
        })
        //console.log(this.contoList)
      })

      const datiDaInviare = { anno: this.annoRiferimentoCorrente, };
      useJwt.post(apiDistinteAnnoUrl, datiDaInviare).then((d) => {
        //console.log("DISTINTE")
        //console.log(d.data);
        this.distintePagamentoFullData = d.data;
        this.distintePagamentoFullData.forEach((obj) => {
          // fix tipo dati conto (trasforma in integer)
          obj.conto = +obj.conto
        })
      });

    } else {
      console.log("Non trovo UserData, prova ancora");
    }

    // Recupero/definisco i valori di default delle entità utilizzate nel componente
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Aggregate],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    soggettiFiltering: function (e) {
      var searchData = this.soggettiList;
      var query = new Query();
      if (e.text != "")
        query = query.where("denominazione", "contains", e.text, true)

      e.updateData(searchData, query);
    },
    onAnnoRiferimentoChange: function (e) {
      console.log("Change")
      console.log("Recupero elenco distinte pagamento per l'anno selezionato");
      const datiDaInviare = { anno: this.annoRiferimentoCorrente, };
      useJwt.post(apiDistinteAnnoUrl, datiDaInviare).then((d) => {
        //console.log("Distinte pagamento")
        //console.log(d.data);
        this.distintePagamentoFullData = d.data;
        this.distintePagamentoFullData.forEach((obj) => {
          // fix tipo dati conto (trasforma in integer)
          obj.conto = +obj.conto
        })
      });
    },
    async onSoggettoChange(e) {
      console.log("Cambio soggetto")
      //console.log(this.$refs.soggetto.ej2Instances.value)
      //console.log(this.elementiDistintaActiveData.soggetto)
      if (this.$refs.soggetto.ej2Instances.value === null) {
        console.log("click fuori")
        this.$refs.soggetto.ej2Instances.value = this.id_soggetto_distinta
        this.elementiDistintaActiveData.soggetto = this.id_soggetto_distinta
      } else {
        this.id_soggetto_distinta = this.elementiDistintaActiveData.soggetto
        // adesso devo cercare nella lista soggetti per ID

        const i = this.soggettiList.findIndex((x) => x.id === this.id_soggetto_distinta)
        if (i >= 0) {
          const t = this.soggettiList[i] // ho il soggetto
          if (t.ragioneSociale) {
            this.elementiDistintaActiveData.denominazione = t.ragioneSociale
          } else {
            this.elementiDistintaActiveData.denominazione = t.nome + " " + t.cognome
          }
          this.elementiDistintaActiveData.indirizzo = t.residenzaIndirizzo + " " + t.residenzaComune + " " + t.residenzaCap + " (" + t.residenzaProvincia + "), " + t.residenzaStato
          if(t.banca1IBAN)
            this.elementiDistintaActiveData.iban = t.banca1IBAN
          else
              this.elementiDistintaActiveData.iban = t.banca2IBAN
          this.elementiDistintaActiveData.codicefiscale = t.codiceFiscale
          //console.log(this.elementiDistintaActiveData)
        } else {
          console.log("non trovato")
        }
        const apiRicercaSoggettoUrl = '/demo/api/cashflow/ricerca_per_soggetto'
        const r = await useJwt
              .post(apiRicercaSoggettoUrl, {'soggetto': this.id_soggetto_distinta})
              .then((res) => {
                  this.riferimentiData = res.data
                  //console.log(res.data)
              })
      }
    },
    onRiferimentiBound() {
      if (this.elementiDistintaActiveId !== 0 && this.elementiDistintaActiveData.riferimento != null) {
        const ddl = this.$refs.dropdownRiferimenti.ej2Instances
        ddl.value = this.elementiDistintaActiveData.riferimento
        ddl.dataBind()
      }
    },
    onRiferimentoChange: function (e) {
      console.log("Cambio riferimento operazione soggetto")
      //console.log(this.riferimentiData)
      const indice = this.riferimentiData.findIndex((x) => x.id === this.elementiDistintaActiveData.riferimento)
      if (indice != -1) {
        //console.log("tipo riferimento")
        //console.log(this.riferimentiData[indice].tipo_riferimento)
        this.elementiDistintaActiveData.tipo_riferimento = this.riferimentiData[indice].tipo_riferimento
      }
    },
    // per dialogA
    dialogAOpen(args) {
      console.log("Apertura dialogA");

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogAClose() {
      console.log("Chiusura dialogA");
      this.dialogA.tabAdialogAIndex = 0;
      //console.log(this.distintePagamentoActiveData);
    },
    dialogAOk() {
      console.log("Cliccato bottone OK di dialogA");
      // salvataggio informazioni in remoto
      if (this.distintePagamentoActiveId === 0) {
        // salvataggio in caso di new
        useJwt
          .post(apiDistinteUrl, this.distintePagamentoActiveData)
          .then((res) => {
            // TODO: gestione errore creazione
            if (res.status == 200 || res.status == 201) {
              console.log("Distinta CREATA")
              //console.log(res.data)
              // mi segno ID elemento appena creato
              this.distintePagamentoActiveId = res.data.id;
              this.makeToast( "primary", "Successo", "Creazione della distinta avvenuta")
            } else {
              this.makeToast( "primary", "ERRORE", "Errore nella creazione della distinta");
            }
            return this; // restituisci contesto per permettere aggiornamento grid
          })
          .then((context) => {
            // faccio post di tutti gli elementi e li salvo uno ad uno lato server
            const datiDaInviare = {
              'distinta_id': this.distintePagamentoActiveId,
              'elementi': this.elementiDistintaFullData,
            }
            useJwt.post(apiElementiDistintaCreateUrl, datiDaInviare).then((res) => {
              if (res.status == 200 || res.status == 201) {
                console.log(res.data)
              }
              // TODO: gestione errore
            });
            return context
          })
          .then((context) => {
            const datiDaInviare = { anno: context.annoRiferimentoCorrente, };
            useJwt.post(apiDistinteAnnoUrl, datiDaInviare).then((res) => {
              console.log("Aggiornamento gridA dopo aggiunta distinta");
              context.distintePagamentoFullData = res.data;
              context.distintePagamentoFullData = [...context.distintePagamentoFullData];
              //console.log(context.distintePagamentoFullData)
            });
          });
      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiDistinteUrl}/${this.distintePagamentoActiveId}`;
        // console.log(this.distintePagamentoActiveData)
        useJwt
          .patch(editUrl, this.distintePagamentoActiveData)
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.makeToast(
                "primary",
                "Successo",
                "Modifica della distinta pagamento"
              );
            }
            return this
          }).then((context) => {
            const datiDaInviare = { anno: context.annoRiferimentoCorrente, };
            useJwt.post(apiDistinteAnnoUrl, datiDaInviare).then((d) => {
              //console.log("DISTINTE")
              //console.log(d.data);
              context.distintePagamentoFullData = d.data;
            });
          })
      }
      this.$refs.dialogA.hide();
    },
    dialogACancel() {
      console.log("Cliccato bottone Cancel di dialogA");
      this.$refs.dialogA.hide();
    },
    // per gridA
    gridAClickHandler(args) {
      if (args.item.id === "new") {
        this.dialogA.header = "Nuova Distinta"
        const oggi = new Date

        let pos = this.contoList.findIndex((obj) => obj.label === 'BPM Ordinario')
        if (pos == -1) { pos = 0; }
        this.distintePagamentoActiveData = {
            id: 0,
            data: oggi,
            numero: null,
            conto: +this.contoList[pos].val,
            descrizione: null,
            stato: null,
            iban: null,
            importo: 0,
            tipo_pagamento: null,
        }
        console.log("Premuto pulsante creazione nuova distinta da gridA")
        // console.log(this.distintePagamentoActiveData);
        // console.log(this.praticheVVFDefaultData);
        this.distintePagamentoActiveId = 0
        this.elementiDistintaFullData = []
        this.$refs.dialogA.show(true)
      }
      else if (args.item.id === "edit") {
        console.log("Premuto pulsante modifica distinta da gridA");
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.distintePagamentoActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:")
          // console.log(this.distintePagamentoActiveId)
          const i = this.distintePagamentoFullData.findIndex(
            (x) => x.id === this.distintePagamentoActiveId
          )
          if (i >= 0) {
            this.distintePagamentoActiveData = this.distintePagamentoFullData[i]
            this.distintePagamentoActiveData.conto = +this.distintePagamentoActiveData.conto
            this.elementiDistintaFullData = this.distintePagamentoActiveData.elementi
            //console.log("elementi distinta fulldata")
            //console.log(this.elementiDistintaFullData)

            this.elementiDistintaFullData.forEach((obj) => {
              const j = this.soggettiList.findIndex((x) => x.id === obj.soggetto)
              if (j >= 0) {
                const t = this.soggettiList[j] // ho il soggetto
                if (t.ragioneSociale) {
                  obj.denominazione = t.ragioneSociale
                } else {
                  obj.denominazione = t.nome + " " + t.cognome
                }
              } else {
                console.log("soggetto non trovato")
                console.log(obj.soggetto)
              }
            })
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella")
          this.alertAShow()
        }

        this.$refs.dialogA.show(true)
      } else if (args.item.id === "delete") {
        try {
          console.log("Premuto pulsante elimina distinta da gridA")
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          const deletedElementId = selectedRow[0].id
          const deleteUrl = `${apiDistinteUrl}/${deletedElementId}`
          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo")
            this.$refs.gridA.ej2Instances.deleteRecord()
          }).catch((err) => {
            console.log(err)
            this.makeToast("danger", "Errore", "Eliminazione distinta fallita")
          })
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      } else if (args.item.id === "download") {
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          useJwt.post(apiDistinteGeneraUrl, {'id': selectedRow[0].id}).then((d) => {
            const nomeFile = d.data['fileDocumento'].split('\\').pop().split('/').pop().split('?')[0]
            const link = document.createElement("a");
            link.href = d.data['fileDocumento']
            link.setAttribute("download", nomeFile);
            document.body.appendChild(link);
            link.click();
          })
        } catch (err) {
          console.log(err);
          this.alertAShow();
        }
      } else if (args.item.id === "download-bancario") {
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          useJwt.post(apiDistinteBancarioUrl, {'id': selectedRow[0].id}).then((d) => {
            const nomeFile = "fileBancario.txt"
            const url = window.URL.createObjectURL(new Blob([d.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', nomeFile)
            document.body.appendChild(link)
            link.click()
          })
        } catch (err) {
          console.log(err);
          this.alertAShow();
        }
      } else if (args.item.id === "download-xml") {
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          useJwt.post(apiDistinteBancarioXMLUrl, {'id': selectedRow[0].id}).then((d) => {
            const url = window.URL.createObjectURL(new Blob([d.data]))
            const link = document.createElement('a')
            const nomeFile = d.headers['content-disposition'].split('=').pop()
            link.href = url
            link.setAttribute("download", nomeFile);
            document.body.appendChild(link)
            link.click()
          })
        } catch (err) {
          console.log(err);
          this.alertAShow();
        }
      }
    },
    // per dialogB
    async dialogBOpen(args) {
      // CCC
      if (this.elementiDistintaActiveId == 0) {
        this.elementiDistintaActiveData = {
          'soggetto': null,
          'denominazione': null,
          'indirizzo': null,
          'codicefiscale': null,
          'iban': null,
          'swift': null,
          'importo': 0,
          'tipo_pagamento': null,
          'descrizione': null,
          'acconto': false,
          'saldo': false,
          'riferimento': null,
        }
        this.riferimentiData = []
        this.$refs.soggetto.ej2Instances.value = null
        this.$refs.soggetto.ej2Instances.dataBind()
      } else if (this.elementiDistintaActiveData.soggetto) {
        const apiRicercaSoggettoUrl = '/demo/api/cashflow/ricerca_per_soggetto'
        await useJwt
          .post(apiRicercaSoggettoUrl, { 'soggetto': this.elementiDistintaActiveData.soggetto })
          .then((res) => {
            this.riferimentiData = res.data
          })
      }
      console.log("Apertura dialogB");
      // todo restore dropdown
      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();
    },
    dialogBClose() {
      console.log("Chiusura dialogB");
      this.dialogB.tabAdialogBIndex = 0;
    },
    async dialogBOk() {
      console.log("Cliccato bottone OK di dialogB");
      // console.log(this.elementiDistintaActiveId)
      if (this.elementiDistintaActiveId == 0) {
        console.log("NEW elemento")
        if (this.distintePagamentoActiveId != 0) {
          // crea elemento distinta su distinta esistente: aspetta la risposta per avere l'id reale
          this.elementiDistintaActiveData.distinta = this.distintePagamentoActiveId
          await useJwt.post(apiElementiDistintaUrl, this.elementiDistintaActiveData).then((d) => {
            this.elementiDistintaActiveData = d.data
            const j = this.soggettiList.findIndex((x) => x.id === this.elementiDistintaActiveData.soggetto)
            if (j >= 0) {
              const t = this.soggettiList[j]
              this.elementiDistintaActiveData.denominazione = t.ragioneSociale
                ? t.ragioneSociale
                : t.nome + " " + t.cognome
            }
            this.elementiDistintaFullData.push(this.elementiDistintaActiveData)
            this.elementiDistintaFullData = [...this.elementiDistintaFullData]
          });
        } else {
          // distinta non ancora salvata: aggiungi solo localmente
          const j = this.soggettiList.findIndex((x) => x.id === this.elementiDistintaActiveData.soggetto)
          if (j >= 0) {
            const t = this.soggettiList[j]
            this.elementiDistintaActiveData.denominazione = t.ragioneSociale
              ? t.ragioneSociale
              : t.nome + " " + t.cognome
          }
          this.elementiDistintaFullData.push(this.elementiDistintaActiveData)
          this.elementiDistintaFullData = [...this.elementiDistintaFullData]
        }

      } else {
        // fare patch
        console.log("edit elemento")
        //console.log(this.elementiDistintaActiveData)

        const editUrl = `${apiElementiDistintaUrl}/${this.elementiDistintaActiveId}`;
        useJwt.patch(editUrl, this.elementiDistintaActiveData)
              .then((res) => {
                if (res.status == 200 || res.status == 201) {
                  this.makeToast(
                    "primary",
                    "Successo",
                    "Modifica di un elemento distinta"
                  );
                }

                const i = this.elementiDistintaFullData.findIndex(
                  (x) => x.id === this.elementiDistintaActiveId
                )
                if (i >= 0) {
                  this.elementiDistintaFullData[i] = res.data

                  // aggiorna ragioneSociale soggetto
                  const j = this.soggettiList.findIndex((x) => x.id === res.data['soggetto'])
                  if (j >= 0) {
                    const t = this.soggettiList[j]
                    if (t.ragioneSociale) {
                      this.elementiDistintaFullData[i].denominazione = t.ragioneSociale
                    } else {
                      this.elementiDistintaFullData[i].denominazione = t.nome + " " + t.cognome
                    }
                  }
                  this.elementiDistintaFullData = [...this.elementiDistintaFullData]
                }
              })
      }
      this.$refs.dialogB.hide();
    },
    dialogBCancel() {
      console.log("Cliccato bottone Cancel di dialogB");
      this.$refs.dialogB.hide();
    },
    gridDClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "new") {
        // nuovo elemento
        this.elementiDistintaActiveId = 0
        this.$refs.dialogB.show(true);
      } else if (args.item.id === "edit") {
        // edit
        try {
          const selectedRow = this.$refs.gridD.getSelectedRecords()
          this.elementiDistintaActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:")
          console.log(this.elementiDistintaActiveId)
          const i = this.elementiDistintaFullData.findIndex(
            (x) => x.id === this.elementiDistintaActiveId
          )
          if (i >= 0) {
            this.elementiDistintaActiveData = this.elementiDistintaFullData[i]
          }
        } catch (err) {
          console.log("Occorre selezionare una riga della tabella")
          this.alertAShow()
        }
        this.$refs.dialogB.show(true);
      } else if (args.item.id === "delete") {
        // Pulsante DELETE
        // cancella elemento distinta
        try {
          console.log("Premuto pulsante elimina di gridD");
          // delete
          const selectedRow = this.$refs.gridD.getSelectedRecords()
          const deletedElementId = selectedRow[0].id
          const deleteUrl = `${apiElementiDistintaUrl}/${deletedElementId}`
          useJwt.delete(deleteUrl).then((res) => {
            console.log("Eliminazione avvenuta con successo")
            // console.log(res.data)
          })
          this.$refs.gridD.ej2Instances.deleteRecord();
        } catch (err) {
          console.log(err);
          console.log("Occorre selezionare una riga della tabella");
          this.alertAShow();
        }
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
